/**
 * Created by renatolovizotto on 13/07/17.
 */
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/SearchStudent.scss";
import Breadcrumb from "../components/Breadcrumb";
import List from "../components/List";
import AuthStore from "../stores/AuthStore";
import SchoolStore from "../stores/SchoolStore";
import {Loader} from '../components/Loader';

@inject('Navigator', 'ConfigStore', 'StudentStore', 'AuthStore', 'SchoolStore')
@observer
export default class SearchStudent extends Component {

    static breadcrumbSegments = [
        {
            title: "Portal do professor",
            uri: "/"
        },
        {
            title: "Busca de aluno",
            uri: ""
        }];

    constructor(props) {
        super(props);

        this.state = {
            searchStudent: '',
            studentId: '',
            students: []
        }
    }

    componentWillMount() {
        this.props.SchoolStore.showStudents = false;
        // Solicitado que as combos permanecam cos os valores quando alterna de uma pagina para outra
        //this.props.SchoolStore.classSelected = {};
        //this.props.SchoolStore.schoolSelected = {};

        const searchStudent = this.props.params.searchStudent;
        this.setState({searchStudent:searchStudent});
        const {
            studentId
        } = this.props.params;

        let studentSearched = searchStudent;
        let unit_id = null;
        if( searchStudent == undefined) {
            if (studentId) {
                studentSearched = this.props.SchoolStore.students.find(s => s.cpf === studentId);
                unit_id =  studentSearched.unitIdSf;
                studentSearched = studentSearched.firstName + ' ' + studentSearched.lastName;
            }
        }

        if( unit_id == null ) {
            unit_id = AuthStore.units[0].id;
        }

        if(!this.props.SchoolStore.isDetail) {
            this.props.SchoolStore.isLoading = true;
            this.props.SchoolStore.searchStudent(studentSearched,unit_id).then(
                response => {
                    if( response == false) {
                        this.props.SchoolStore.noResult = true;
                    } else {
                        this.props.SchoolStore.noResult = false;
                    }
                    this.props.SchoolStore.isLoading = false;
                }
            );
        }
    }

    handleBreadcrumbClick(uri) {
        this.props.Navigator.replace(uri);
    }

    handleClickStudent(studentId) {
        this.props.SchoolStore.isDetail = true;
        this.props.Navigator.push(`/detail-student/${studentId}`);
    }

    render() {
        if( this.props.SchoolStore.isLoading == false ) {
            const {
                studentId
            } = this.props.params;

            let studentSearched;
            if (studentId) {
                studentSearched = this.props.SchoolStore.students.find(s => s.cpf === studentId);
            }

            let resultSearch = this.props.SchoolStore.students;

            var list = [];
            if ( this.props.SchoolStore.noResult == false ) {
                 list = resultSearch.map(
                    student => {
                        return (
                            <div className="student" key={student.cpf}
                                 onClick={this.handleClickStudent.bind(this, student.cpf)}>
                                <div className="photo" style={{backgroundImage: `url(${student.photo})`}}/>
                                <div className="infos">
                                    <div className="name">{student.fullname}</div>
                                    <div className="level">Level: {student.level}</div>
                                    <div className="email">Email: {student.email}</div>
                                </div>
                            </div>
                        )
                    }
                );
            }

            this.props.SchoolStore.isDetail = false;

            let fullname = '';

            if( studentSearched ){
                if( studentSearched.fullname ) {
                    fullname = studentSearched.fullname;
                } else {
                    fullname = studentSearched.firstName + ' ' + studentSearched.lastName;
                }
            }

            return (
                <div className="SearchStudent Page">
                    <div className="container">
                        <div className="header-section">
                            <h1>Busca de aluno:
                                {
                                    (studentId && studentSearched) && fullname
                                }
                            </h1>
                            <Breadcrumb segments={SearchStudent.breadcrumbSegments}
                                        onClick={this.handleBreadcrumbClick.bind(this)}/>
                            <p className="btn-back" onClick={() => this.props.Navigator.goBack()}>&lt; voltar</p>
                        </div>
                        <div className="contents">
                            {!studentId &&
                            <List counter={list.length}
                                  messageEmpty={'Nenhum aluno encontrado.'}
                                  loader={this.props.StudentStore.isLoading}>
                                {list}
                            </List>
                            }

                            {(studentId && studentSearched) &&
                            <div className="student-detail">
                                <div className="photo" style={{backgroundImage: `url(${studentSearched.photo})`}}/>
                                <div className="infos">
                                    <div className="name">
                                        {
                                            fullname
                                        }
                                    </div>
                                    <p>CPF: {studentSearched.cpf}</p>
                                    {/* <p>Level: {studentSearched.level}</p> */}
                                    {/* <p>Class: {studentSearched.className}</p> */}
                                    <p>Data de Registro: {studentSearched.startDate}</p>
                                    {/*<br/>*/}
                                    {/*<strong>Modules:</strong>*/}
                                    {/*<div className="modules">*/}
                                        {/*<ul>*/}
                                            {/*{studentSearched.modules &&*/}
                                            {/*studentSearched.modules.map(*/}
                                                {/*(m, index) => (*/}
                                                    {/*<li key={index}>*/}
                                                        {/*<span>{m.name}</span>*/}
                                                        {/*<span>{m.level}</span>*/}
                                                    {/*</li>*/}
                                                {/*)*/}
                                            {/*)*/}
                                            {/*}*/}
                                        {/*</ul>*/}
                                    {/*</div>*/}

                                </div>
                            </div>
                            }

                        </div>

                    </div>
                </div>
            );
        } else {
            return (<Loader inverted />);
        }


    }

}


// WEBPACK FOOTER //
// ./src/containers/SearchStudent.js